import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';
import { createRef } from 'react';

import type { RefObject } from 'react';

import { MenuButton } from './MenuButton';

const onClickSpy = jest.fn();

describe('LinkButton', () => {
  it('should render', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="primary" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
  });

  it('should render primary', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="primary" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--primary');
  });

  it('should render secondary', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="secondary" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--secondary');
  });

  it('should render destructive-primary', () => {
    const testRef = createRef();
    render(
      <MenuButton
        variant="destructive-primary"
        onClick={onClickSpy}
        buttonRef={testRef as RefObject<HTMLButtonElement>}
      >
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--destructive-primary');
  });

  it('should render destructive-secondary', () => {
    const testRef = createRef();
    render(
      <MenuButton
        variant="destructive-secondary"
        onClick={onClickSpy}
        buttonRef={testRef as RefObject<HTMLButtonElement>}
      >
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--destructive-secondary');
  });

  it('should render blank', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="blank" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--blank');
  });

  it('should render blank-icon', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="blank-icon" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    expect(screen.getByText('Test MenuButton')).toBeInTheDocument();
    expect(screen.getByText('Test MenuButton')).toHaveClass('button--blank-icon');
  });

  it('should fire when clicked', () => {
    const testRef = createRef();
    render(
      <MenuButton variant="blank-icon" onClick={onClickSpy} buttonRef={testRef as RefObject<HTMLButtonElement>}>
        Test MenuButton
      </MenuButton>
    );
    fireEvent.click(screen.getByText('Test MenuButton'));
    expect(onClickSpy).toHaveBeenCalledTimes(1);
  });
});
